<template>
  <div>
    <VOfferSegmentListItem
      v-for="segment in segments"
      :key="segment.segment_id"
      @copy="$emit('copy', segment)"
      @edit="$emit('edit', segment)"
      @remove="$emit('remove', segment)"
      :segment="segment"
      :offerType="offerType ? offerType : ''"
      :isReadonly="isReadonly"
    ></VOfferSegmentListItem>
  </div>
</template>
<script>
  import VOfferSegmentListItem from "./VOfferSegmentListItem";
  export default {
    name: "VOfferSegmentList",
    components: { VOfferSegmentListItem },
    props: {
      segments: {
        required: true,
        type: Array
      },
      offerType: {
        required: true,
        type: String
      },
      isReadonly: {
        required: true,
        type: Boolean
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/VOfferSegmentList.vue